import {cleanEntity} from "@mytour/platform";
import type {
  CreateScheduledReminderPayload,
  PreviewReminderDatesPayload,
  PreviewReminderDatesResponse,
  ScheduledReminderResponse,
  SmsStatusPayload,
} from "@mytour/shared";
import {SmsStatusPayloadSchema} from "@mytour/shared";
import axios from "axios";

export const reminderApiService = {
  async previewDates(payload: PreviewReminderDatesPayload): Promise<PreviewReminderDatesResponse> {
    const result = await axios.post<PreviewReminderDatesResponse>(
      "api/scheduled-reminders/preview-dates",
      payload
    );
    return result.data;
  },
  async getSmsStatus(): Promise<SmsStatusPayload> {
    const result = await axios.get<SmsStatusPayload>(
      "api/platform-users/notifications/sms-status"
    );
    return SmsStatusPayloadSchema.parse(result.data);
  },
  async createReminder(
    payload: CreateScheduledReminderPayload
  ): Promise<ScheduledReminderResponse> {
    const result = await axios.post<ScheduledReminderResponse>(
      "api/scheduled-reminders/",
      cleanEntity(payload)
    );
    return result.data;
  },

  async cancelReminder(reminderId: string): Promise<void> {
    await axios.post(`api/scheduled-reminders/${reminderId}/cancel`);
  },

  async findActiveForCustomer(customerId: string): Promise<ScheduledReminderResponse | null> {
    const result = await axios.get<ScheduledReminderResponse | null | "">(
      `api/scheduled-reminders/customer/${customerId}`
    );
    return result.data === "" ? null : result.data;
  },
};
